import React from 'react'
import { Image } from 'react-bootstrap'
import Slider from "react-slick";
import { Link } from 'react-router-dom';
import { ASSET_URL } from './../../constant';

const CardChildCategory = (props) => {

    const { childs } = props;

    const categorySlick = {
        swipe: false,
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 2,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                }
            },
            {
                breakpoint: 600,
                settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                slidesToShow: 1,
                slidesToScroll: 1
                }
            }
        ]
    };

    return (
        <div>
            <p className="fs-6 my-3 fw-bold text-uppercase">All Categories of {props.categoryName}</p>
            <Slider {...categorySlick} className="my-2">
                {childs.map((x, i) =>
                    <Link key={i} className="slideCat" to={`/categories/${x.slug_plus_parent}`}>
                        <Image src={ASSET_URL + JSON.parse(x.thumbnail)[0].url} />
                        <p>{x.name}</p>
                    </Link>
                )}
            </Slider>
        </div>
        
    )
}

export default CardChildCategory
